import { Outlet } from "react-router-dom";

export default function NonAuthenticatedLayout() {
  return (
    <div className="min-h-screen">
      <Outlet />
    </div>
  );
}
